import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import UserActions from "../../store/user/Actions";
import { connect } from "react-redux";
import Images from "../../images";
import "../App/App.scss";
import "../../css/bootstrap.css";
import "./HomeScreen.css";
import LessonPodItem from "../CommonItems/LessonPodItem";
import LessonPodItemSkeleton from "../CommonItems/LessonPodItemSkeleton";
import ActivityList from "../CommonItems/ActivityList";
import { Column, Grid } from "carbon-components-react";
import home_banner_kids_video from "../../animations/Banner_Kids.mp4";
import EmptyScreen from "../CommonItems/EmptyScreen";
import { GET_LESSON_UNITS, GET_UPCOMIN_ASSIGN_LIST } from "../../constants";

function HomeScreen(props) {
  const history = useHistory();
  const { user, token } = props; // get local data
  const { getLessonUnitDetailsForStudent, getUpcomingAssignmentForStudent } =
    props; //Api's
  const {
    setHeaderTitle,
    setShowHideLoader,
    saveUnitName,
    saveFromAnalytics,
    saveFromCourse,
    onHeaderItemSelected,
    saveCourseName,
    showOrHideToaster,
    refreshToken,
    userToken,
  } = props; //store local
  const [displayActivityModal, setDisplayActivityModal] = useState(false);
  const [upcomingAssignmentList, setUpcomingAssignmentList] = useState([]);
  // const [selectedAssaignmentData, setSelectedAssaignmentData] = useState({});
  const [internalLoading, setInternalLoading] = useState(false);
  const [internalLoadingPopup, setInternalLoadingPopup] = useState(false);
  const [lessonUnitDetails, setLessonUnitDetails] = useState({});
  const [saveUserErrorCount, setSaveUserErrorCount] = useState(0);
  const selectedAssaignmentData = useRef({});

  useEffect(() => {
    setHeaderTitle("Course Dashboard");
    onHeaderItemSelected("home");
    setShowHideLoader(false);
  }, []);

  useEffect(() => {
    return () => {
      if (history.action === "POP") {
        history.go(1);
      }
    };
  }, [history]);

  useEffect(() => {
    setInternalLoading(true);
    getUpcomingAssignList(token);
  }, []);

  function getUpcomingAssignList(tokenData) {
    getUpcomingAssignmentForStudent(
      user.LoginID,
      "All",
      tokenData,
      (upcomingAssignments) => {
        if (upcomingAssignments.StatusCode === 200) {
          setTimeout(() => {
            setSaveUserErrorCount(0);
            setInternalLoading(false);
            setUpcomingAssignmentList(
              upcomingAssignments.Data.GetBPUpcomingAssignmentsResult
            );
          }, 2000);
        } else if (upcomingAssignments.StatusCode === 401) {
          if (saveUserErrorCount < 1) {
            refreshTokenCall(GET_UPCOMIN_ASSIGN_LIST);
          } else {
            showOrHideToaster(
              true,
              "Server failed! Please try again.",
              "error"
            );
            setSaveUserErrorCount(0);
            setInternalLoading(false);
          }
        } else {
          setInternalLoading(false);
          showOrHideToaster(true, upcomingAssignments.StatusMessage, "error");
        }
      }
    );
  }

  function getLessonUnitDetails(
    lessonUnitDistId,
    lessonUnitName,
    selectedCourseName,
    tokenData
  ) {
    setLessonUnitDetails({});
    setDisplayActivityModal(true);
    setInternalLoadingPopup(true);
    saveFromAnalytics(false);
    saveUnitName(lessonUnitName);
    saveCourseName(selectedCourseName);
    saveFromCourse(false);
    getLessonUnitDetailsForStudent(
      user.LoginID,
      lessonUnitDistId,
      tokenData,
      (activitiesList) => {
        if (activitiesList.StatusCode === 200) {
          setTimeout(() => {
            setSaveUserErrorCount(0);
            setInternalLoading(false);
            setLessonUnitDetails(activitiesList);
            setInternalLoadingPopup(false);
          }, 1500);
        } else if (activitiesList.StatusCode === 401) {
          if (saveUserErrorCount < 1) {
            refreshTokenCall(GET_LESSON_UNITS);
          } else {
            showOrHideToaster(
              true,
              "Server failed! Please try again.",
              "error"
            );
            setSaveUserErrorCount(0);
            setInternalLoading(false);
          }
        } else {
          setInternalLoading(false);
          showOrHideToaster(true, activitiesList.StatusMessage, "error");
        }
      }
    );
  }

  function refreshTokenCall(apiType) {
    refreshToken(token, (tokenResponse) => {
      if (tokenResponse.Success) {
        if (apiType === GET_UPCOMIN_ASSIGN_LIST) {
          getUpcomingAssignList(tokenResponse.Token);
        } else if (apiType === GET_LESSON_UNITS) {
          getLessonUnitDetails(
            selectedAssaignmentData.current.LessonUnitDistID,
            selectedAssaignmentData.current.LessonName,
            selectedAssaignmentData.current.CourseName,
            tokenResponse.Token
          );
        }
        userToken(tokenResponse.Token);
        setSaveUserErrorCount(1);
      } else {
        showOrHideToaster(true, "Server failed! Please try again.", "error");
        setSaveUserErrorCount(0);
        setInternalLoading(false);
      }
    });
  }

  function getFormattedDateChange(dateValue) {
    var dateFormat = "";
    if (dateValue && dateValue !== "") {
      var dt = new Date(dateValue);
      var months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      var day = dt.getDate().toString();
      day = day.length > 1 ? day : "0" + day;
      dateFormat = day + " " + months[dt.getMonth()];
    } else {
      dateFormat = "";
    }
    return dateFormat;
  }

  const lessonItemColorOdd = ["#4922fd", "#3ec986"];
  const lessonItemColorEven = ["#00b2ff", "#FFC42D"];

  function getRandomItem(arr) {
    // get random index value
    const randomIndex = Math.floor(Math.random() * arr.length);
    // get random item
    const item = arr[randomIndex];
    return item;
  }

  function renderUpcomingAssignments() {
    if (upcomingAssignmentList && upcomingAssignmentList.length > 0) {
      return (
        <Grid className="home-grid-style" condensed fullWidth>
          {upcomingAssignmentList &&
            upcomingAssignmentList.map((assignment, index) => {
              return (
                <Column
                  key={index.toString()}
                  className="home-column-style"
                  lg={4}
                  md={4}
                  sm={4}
                  onClick={() => {
                    selectedAssaignmentData.current = assignment;
                    // setSelectedAssaignmentData(assignment);
                    getLessonUnitDetails(
                      assignment.LessonUnitDistID,
                      assignment.LessonName,
                      assignment.CourseName,
                      token
                    );
                  }}
                >
                  <LessonPodItem
                    CourseName={assignment.CourseName}
                    LessonName={assignment.LessonName}
                    DueDate={getFormattedDateChange(
                      assignment.TargetCompletionDateTime
                    )}
                    LessonColor={
                      index % 2
                        ? getRandomItem(lessonItemColorEven)
                        : getRandomItem(lessonItemColorOdd)
                    }
                  />
                </Column>
              );
            })}
        </Grid>
      );
    } else {
      return (
        <EmptyScreen
          imageAnime={Images.empty_anim_3}
          emptyMessage={"Looks like you don’t have any lessons to complete"}
        />
      );
    }
  }

  return (
    <div className="home-main-container">
      <div className="banner-container">
        <video
          key={"ban_kids_video1"}
          className="banner-video"
          width="100%"
          height="100%"
          autoPlay
          loop
          muted
        >
          <source src={home_banner_kids_video} type="video/mp4" />
        </video>
        <div className="user-label-cont">
          <p className="banner-user-label">Welcome {user.FullName} ! </p>
        </div>
      </div>
      <div className="home-lesson-container">
        {internalLoading ? (
          <Grid className="home-grid-style" condensed fullWidth>
            {Array.from(Array(8)).map((assignment, index) => {
              return (
                <Column
                  key={"homeLessonSkel" + index.toString()}
                  className="home-column-style"
                  lg={4}
                  md={4}
                  sm={4}
                >
                  <LessonPodItemSkeleton />
                </Column>
              );
            })}
          </Grid>
        ) : (
          <div className="data-container" style={{ paddingLeft: "0px" }}>
            {renderUpcomingAssignments()}
          </div>
        )}
      </div>
      {displayActivityModal && (
        <ActivityList
          activityListData={
            lessonUnitDetails.Data &&
            lessonUnitDetails.Data.GetLessonUnitDetailsForAStudentResult &&
            lessonUnitDetails.Data.GetLessonUnitDetailsForAStudentResult
              .length > 0
              ? lessonUnitDetails.Data.GetLessonUnitDetailsForAStudentResult
              : []
          }
          selectedCourseName={
            selectedAssaignmentData.current.CourseName
              ? selectedAssaignmentData.current.CourseName
              : ""
          }
          selectedLessonName={
            selectedAssaignmentData.current.LessonName
              ? selectedAssaignmentData.current.LessonName
              : ""
          }
          selectedTargetDate={
            selectedAssaignmentData.current.TargetCompletionDateTime
              ? getFormattedDateChange(
                  selectedAssaignmentData.current.TargetCompletionDateTime
                )
              : ""
          }
          selectedAssignmentData={selectedAssaignmentData.current}
          onCloseClick={() => {
            setDisplayActivityModal(false);
          }}
          internalLoading={internalLoadingPopup}
        />
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  user: state.user.user,
  token: state.user.token,
});

const mapDispatchToProps = (dispatch) => ({
  getUpcomingAssignmentForStudent: (
    studentId,
    assignmentDate,
    token,
    successFn
  ) =>
    dispatch(
      UserActions.getUpcomingAssignmentForStudent(
        studentId,
        assignmentDate,
        token,
        successFn
      )
    ),
  saveUnitName: (unitName) => dispatch(UserActions.saveUnitName(unitName)),
  getLessonUnitDetailsForStudent: (
    studentId,
    lessonUnitDistId,
    token,
    successFn
  ) =>
    dispatch(
      UserActions.getLessonUnitDetailsForStudent(
        studentId,
        lessonUnitDistId,
        token,
        successFn
      )
    ),
  setHeaderTitle: (headerTitle) =>
    dispatch(UserActions.setHeaderTitle(headerTitle)),
  setShowHideLoader: (status) =>
    dispatch(UserActions.setShowHideLoader(status)),

  saveFromAnalytics: (fromAnalytics) =>
    dispatch(UserActions.saveFromAnalytics(fromAnalytics)),
  saveFromCourse: (fromCourse) =>
    dispatch(UserActions.saveFromCourse(fromCourse)),
  onHeaderItemSelected: (headerItemSelected) =>
    dispatch(UserActions.onHeaderItemSelected(headerItemSelected)),
  saveCourseName: (currentCourseName) =>
    dispatch(UserActions.saveCourseName(currentCourseName)),
  refreshToken: (tokenData, successFn) =>
    dispatch(UserActions.refreshToken(tokenData, successFn)),
  userToken: (token) => dispatch(UserActions.userToken(token)),
  showOrHideToaster: (showToastModal, toastMessageText, toastType) =>
    dispatch(
      UserActions.showOrHideToaster(showToastModal, toastMessageText, toastType)
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(HomeScreen);
